var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-bar"},[_c('img',{staticClass:"logo",staticStyle:{"width":"46px","height":"46px","margin-right":"0px"},attrs:{"src":require("@/assets/logo.jpg"),"alt":"logo"}}),_c('span',{staticClass:"navtitle"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }